import React from "react";
import {
  CardContainer,
  CardContent,
  CardIconWrapper,
  CardTitle,
  CardValue,
} from "./style";
const SingleMiniCard = ({ title, value, icon }) => {
  return (
    <CardContainer>
      <CardIconWrapper>
        {React.cloneElement(icon, { style: { fontSize: "inherit" } })}
      </CardIconWrapper>
      <CardContent>
        <CardTitle>{title}</CardTitle>
        <CardValue>{value}</CardValue>
      </CardContent>
    </CardContainer>
  );
};

export default SingleMiniCard;
